module.exports = __webpack_public_path__ + "img/68.423e6758.jpg";